import { MOVE_TO_NEXT, MOVE_TO_PREV } from '@eventbrite/eds-hot-keys';

// See https://craig.is/killing/mice for available patterns of declaring keyboard sequences.
export const ACTION_KEY_MAP = {
    // action(str) : keyCombination
    [MOVE_TO_NEXT]: 'right',
    [MOVE_TO_PREV]: 'left',
};
